import utils from "../../../utils/utils";

// kaynak id -> GetSocialMediaAccounts accountType (admin panel ekranlarındaki değerler)
const accountTypeBySource = { 1: 1, 2: 2, 5: 10, 11: 9, 20: 6, 23: 11, 24: 12, 28: 15, 29: 16 };

export default {
    async fetchAllAlarms(context) {
        const response = await utils.utility.fetch("api/alarm/getallalarms", "GET", null, null);
        
        context.commit("setAllAlarms", response.data);
    },
    async fetchIndividualAlarms(context) {
        const response = await utils.utility.fetch("api/alarm/getindividualalarms", "GET", null, null);

        context.commit("setIndividualAlarms", response.data);
    },
    async fetchAlarmTypes(context) {
        const response = await utils.utility.fetch("api/alarm/getalarmtypes", "GET", null, null);

        context.commit("setAlarmTypes", response.data);
    },
    async fetchAlarmAccounts(context, payload) {
        const accountType = accountTypeBySource[payload.source];

        if (!accountType) {
            context.commit("setAlarmAccounts", []);

            return;
        }

        const query = `source=${payload.source}&accountType=${accountType}&pageNumber=1&sortColumn=id&sortDirection=desc&searchText=`;

        const countResponse = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?${query}&pageSize=1`, "GET", null, null);
        const totalCount = countResponse.data.totalCount;

        if (!totalCount) {
            context.commit("setAlarmAccounts", []);

            return;
        }

        const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?${query}&pageSize=${totalCount}`, "GET", null, null);

        context.commit("setAlarmAccounts", response.data.items);
    },
    async postAlarm(context, payload) {
        if (payload.typeId == 6) {
            const response = await utils.utility.fetch("api/alarm/postindividualalarm", "POST", null, payload);

            context.commit("setIndividualAlarms", response.data);
        } else {
            const response = await utils.utility.fetch("api/alarm/postalarm", "POST", null, payload);

            context.commit("setAllAlarms", response.data);
        }
    },
    async putAlarmStatus(_, payload) {
        await utils.utility.fetch("api/alarm/updatealarmstatus", "PUT", null, payload);
    },
    async putAlarm(context, payload) {
        const response = await utils.utility.fetch("api/alarm/updatealarm", "PUT", null, payload);

        context.commit("setAllAlarms", response.data);
    },
    async putIndividualAlarm(context, payload) {
        const response = await utils.utility.fetch("api/alarm/updateindividualalarm", "PUT", null, payload);

        context.commit("setIndividualAlarms", response.data);
    },
    async deleteAlarm(context, payload) {
        const response = await utils.utility.fetch("api/alarm/deletealarm", "PUT", null, payload);

        context.commit("setAllAlarms", response.data);
    },
    async deleteIndividualAlarm(context, payload) {
        const response = await utils.utility.fetch("api/alarm/deleteindividualalarm", "PUT", null, payload);

        context.commit("setIndividualAlarms", response.data);
    },
    async postRule(context, payload) {
        const response = await utils.utility.fetch("api/alarm/postrule", "POST", null, payload);

        context.commit("setRule", response.data);
    },
    async fetchAlarmRules(context, payload) {
        const response = await utils.utility.fetch(`api/alarm/getalarmrules?id=${payload.id}`, "GET", null, null);

        context.commit("setAlarmRule", response.data);
    },
    async fetchAlarmNotifications(context) {
        const response = await utils.utility.fetch("api/alarm/getallalarmsummaries", "GET", null, null, true);

        if (response) context.commit("setAlarmSummary", response.data);
    },
    async putReadDates() {
        utils.utility.fetch("api/alarm/updatereaddates", "PUT", null, null, true);
    }
}